import { lazy } from "react";
import UIDs from "../../UIDs";
/** import  { RouteObject } from "react-router-dom"; **/

const HomePage = (lazy(() => import("../../screens/portal/HomeScreen")));
const JoinUsScreen = (lazy(() => import("../../screens/portal/JoinUsScreen")));
const ConsumerScreen = (lazy(() => import("../../screens/portal/ConsumerScreen")));
const ProviderScreen = (lazy(() => import("../../screens/portal/ProviderScreen")));
const SocialContentListScreen = (lazy(() => import("../../screens/portal/SocialContentListScreen")));
const AgentScreen = (lazy(() => import("../../screens/portal/AgentScreen")));
const JoinScreen = (lazy(() => import("../../screens/portal/JoinScreen")));
const AboutScreen = (lazy(() => import("../../screens/portal/AboutScreen")));
const PrivacyScreen = (lazy(() => import("../../screens/portal/PrivacyScreen")));
const TermsScreen = (lazy(() => import("../../screens/portal/TermsScreen")));
const StoreJoinScreen = (lazy(() => import("../../screens/portal/StoreJoinScreen")));
const RegionJoinScreen = (lazy(() => import("../../screens/portal/RegionJoinScreen")));
const CloudStoreJoinScreen = (lazy(() => import("../../screens/portal/CloudStoreJoinScreen")));
const MarketerScreen = (lazy(() => import("../../screens/portal/MarketerScreen")));
const DownloadProviderAppScreen = (lazy(() => import("../../screens/portal/DownloadProviderAppScreen")));
const DownloadConsumerAppScreen = (lazy(() => import("../../screens/portal/DownloadConsumerAppScreen")));
const PaymentScreen = (lazy(() => import("../../screens/portal/PaymentScreen")));
/**
 * @name portalRoutes
 * @type {RouteObject}
 */
export const portalRoutes = [
    {
        path: "/home",
        uid: UIDs.screens.portal.home,
        layout: "/portal",
        element: HomePage,
        index: true,
    },
    {
        path: "/consumer",
        uid: UIDs.screens.portal.consumer,
        layout: "/portal",
        element: ConsumerScreen,
        index: true,
    },
    {
        path: "/joinus",
        uid: UIDs.screens.portal.joinus,
        layout: "/portal",
        element: JoinUsScreen,
    },
    {
        path: "/provider",
        uid: UIDs.screens.portal.provider,
        layout: "/portal",
        element: ProviderScreen,
    },
    {
        path: "/socialcontent",
        uid: UIDs.screens.portal.socialcontentlist,
        layout: "/portal",
        element: SocialContentListScreen,
    },
    {
        path: "/agent",
        uid: UIDs.screens.portal.agent,
        layout: "/portal",
        element: AgentScreen,
    },
    {
        path: "/marketer",
        uid: UIDs.screens.portal.marketer,
        layout: "/portal",
        element: MarketerScreen,
    },
    {
        path: "/join",
        uid: UIDs.screens.portal.join,
        layout: "/portal",
        element: JoinScreen,
    },
    {
        path: "/about",
        uid: UIDs.screens.portal.about,
        layout: "/portal",
        element: AboutScreen,
    },
    {
        path: "/privacy",
        uid: UIDs.screens.portal.privacy,
        layout: "/portal",
        element: PrivacyScreen,
    },
    {
        path: "/terms",
        uid: UIDs.screens.portal.terms,
        layout: "/portal",
        element: TermsScreen,
    },
    {
        path: "/storejoin",
        uid: UIDs.screens.portal.storejoin,
        layout: "/portal",
        element: StoreJoinScreen,
    },
    {
        path: "/regionjoin",
        uid: UIDs.screens.portal.regionjoin,
        layout: "/portal",
        element: RegionJoinScreen,
    },
    {
        path: "/cloudstorejoin",
        uid: UIDs.screens.portal.cloudstorejoin,
        layout: "/portal",
        element: CloudStoreJoinScreen,
    },
    {
        path: "/downloadproviderapp",
        uid: UIDs.screens.portal.downloadproviderapp,
        layout: "/portal",
        element: DownloadProviderAppScreen,
    },
    {
        path: "/downloadconsumerapp",
        uid: UIDs.screens.portal.downloadconsumerapp,
        layout: "/portal",
        element: DownloadConsumerAppScreen,
    },
    {
        path: "/payment",
        uid: UIDs.screens.portal.payment,
        layout: "/portal",
        element: PaymentScreen,
    },
];
